import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {
  CardActions,
  Collapse,
  Grid,
  IconButton,
  IconButtonProps,
  styled,
  Typography,
} from "@mui/material";
import React from "react";

export default function CollapseCardHintCmp(props: any) {
  const fontSize = props.textFontSize! ? props.textFontSize : "16px";

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
  }
  const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    // transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }));

  return (
    <div
      style={{
        border: "1px solid #DAE0E4",
        boxShadow: "1px 2px #dae0e4",
        background: `#F1F4FF`,
        borderRadius: "10px",
        width: "100%",
        marginLeft: props.marginLeft ? props.marginLeft : "10px",
      }}
    >
      {props.hints.length > 1 ? (
        <>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Typography color="text.secondary">
              <div
                style={{
                  fontFamily: "iranSans",
                  color: "#1D4A87",
                  fontSize: fontSize,
                  paddingRight: "20px",
                  paddingTop: "20px",
                }}
              >
                {props.hints?.map((item: any, index: number) => (
                  <p>
                    {index === 0 ? (
                      <label>
                        {props.icon}&nbsp;&nbsp;{item}
                      </label>
                    ) : (
                      <label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{item}
                      </label>
                    )}
                  </p>
                ))}
              </div>
            </Typography>
          </Collapse>
          <CardActions
            disableSpacing
            style={{
              textAlign: !expanded ? "right" : "center",
              padding: "0px",
              width: "100%",
            }}
            className="classCenter"
          >
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              style={{ padding: "0px", width: "100%" }}
            >
              {!expanded ? (
                <Grid
                  container
                  flexDirection={{ xs: "column", lg: "row" }}
                  alignItems={"center"}
                >
                  <Grid
                    item
                    xs={10}
                    style={{ display: "flex" }}
                    paddingX={{ xs: "10px", md: "55px" }}
                  >
                    <div
                      style={{
                        fontFamily: "iranSans",
                        color: "#1D4A87",
                        fontSize: fontSize,
                        paddingTop: "15px",
                        // paddingRight: "20px",
                      }}
                    >
                      <p>
                        <label>
                          {props.icon}&nbsp;&nbsp;{props.hints[0]}
                        </label>
                      </p>
                    </div>
                  </Grid>
                  <Grid
                    item
                    style={{
                      display: "flex",
                      alignContent: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="left"
                      style={{
                        display: "flex",
                        // alignContent: "left"
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#1d4a87",
                          width: "auto",
                          // paddingRight: "20px",
                          paddingTop: "5px",
                        }}
                      >
                        مشاهده بیشتر
                      </span>
                      <div style={{ color: "#1d4a87" }}>
                        <ArrowDropDownIcon
                          style={{ height: "24px", width: "24px" }}
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  flexDirection={{ xs: "column", lg: "row" }}
                  alignItems={"center"}
                >
                  <Grid item xs={10}></Grid>
                  <Grid
                    item
                    style={{
                      display: "flex",
                      alignContent: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="left"
                      style={{
                        display: "flex",
                        // alignContent: "left"
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#1d4a87",
                          width: "auto",
                          paddingTop: "5px",
                        }}
                      >
                        مشاهده کمتر
                      </span>
                      <div style={{ color: "#1d4a87" }}>
                        <ArrowDropUpIcon
                          style={{ height: "24px", width: "24px" }}
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              )}
            </ExpandMore>
          </CardActions>
        </>
      ) : (
        <>
          <Typography color="text.secondary">
            <div
              style={{
                fontFamily: "iranSans",
                color: "#1D4A87",
                fontSize: fontSize,
                paddingRight: "20px",
                paddingTop: "20px",
                marginLeft: "10px",
              }}
            >
              <p>
                <label>
                  {props.icon}&nbsp;&nbsp;{props.hints[0]}
                </label>
              </p>
            </div>
          </Typography>
        </>
      )}
    </div>
  );
}
